import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { STAFF_MEMBERS_STATS_URL } from "api/Service";

/**
 * Summary counts for the User Management stat cards: the tenant's licenced-user limit, active
 * (licensed) users, and deleted users. All three exclude @kinesin.health accounts server-side —
 * see StaffMemberService.getUserStats.
 */
export const useUserStats = (tenantVal) => {
  return useQuery({
    queryKey: ["userStats", tenantVal],
    queryFn: async () => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.get(
        `${tenantVal}${STAFF_MEMBERS_STATS_URL}`
      );
      return response.data;
    },
    enabled: !!tenantVal,
  });
};
